export default __webpack_public_path__ + "static/media/money-back@2x.33e9b585.png";